import React from 'react'
import { Card, Drawer, Form, Icon, notification, Button, Tooltip, Input, Row, Col } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import _ from 'lodash'
import { connect } from 'react-redux'
import TextArea from 'antd/lib/input/TextArea'
import { API_URL, LAPI_URL } from '../../request'
@Form.create()

class WithdrawStudentReasonForm extends React.Component {
    state = {
        visible: true,
        withdrawReason: '',
        withdrawDate: ''
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    doSubmitWithdrawRequest = (e) => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                if (!values.mailFromUniversity && !values.mailFromStudent && !values.otherDocument) {
                    notification.error({
                        message: 'Please Upload At Least One Evidence Below'
                    });
                    return;
                }
                const { recordId, invoiceGenerationRecord } = this.props;
                this.props.onSelect({
                    withdrawReason: values.withdrawReason,
                    mailFromUniversity: values.mailFromUniversity,
                    mailFromStudent: values.mailFromStudent,
                    otherDocument: values.otherDocument,
                    recordId,
                    invoiceGenerationRecord
                });
            }
        })
    }

    render() {
        const { enableBTN, recordId } = this.props;
        const {
            form: { getFieldDecorator, setFieldsValue }
        } = this.props
        const inputTypes = {
            fields: [
                {
                    label: 'Add Note',
                    key: 'withdrawReason',
                    type: 'textarea',
                    required: true,
                    rows: 10
                },
                {
                    label: "Email From University",
                    key: "mailFromUniversity",
                    type: "file",
                    defaultFileList: [],
                },
                {
                    label: "Email From Student",
                    key: "mailFromStudent",
                    type: "file",
                    defaultFileList: [],
                },
                {
                    label: "Other Documents",
                    key: "otherDocument",
                    type: "file",
                    defaultFileList: [],
                }
            ]
        };
        return (
            <Drawer
                title={
                    <div>
                        {'Withdrawal Reason'} {' '}
                        <a onClick={this.onClose} style={{ float: 'right', color: 'black' }}>
                            <Icon type={'close'} />
                        </a>
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}>
                <Card>
                    <Form onSubmit={this.doSubmitWithdrawRequest} style={{ marginTop: 8 }}>
                        <GetAllFormFields
                            apiurl={LAPI_URL}
                            inputSchema={inputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                        <Button
                            type=""
                            htmlType="submit"
                            style={{
                                marginBottom: 10,
                                marginLeft: '33%',
                                backgroundColor: 'green',
                                color: 'white'
                            }}
                            loading={this.props.loading}>
                            SAVE
                        </Button>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WithdrawStudentReasonForm)